import { MaskedInput as BaseMaskedInput } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseMaskedInput)
